import React from 'react';
import '../loading.css';

const Loading = () => {

    return (
    <div className="container mt-5">
          <div class="windows8">
	<div class="wBall" id="wBall_1">
		<div class="wInnerBall"></div>
	</div>
	<div class="wBall" id="wBall_2">
		<div class="wInnerBall"></div>
	</div>
	<div class="wBall" id="wBall_3">
		<div class="wInnerBall"></div>
	</div>
	<div class="wBall" id="wBall_4">
		<div class="wInnerBall"></div>
	</div>
	<div class="wBall" id="wBall_5">
		<div class="wInnerBall"></div>
	</div>
</div>
    </div>
      
    )
}

export default Loading 


// WEBPACK FOOTER //
// ./src/Components/Loading.js